<template>
  <div
    :class="{ 'search-tabs-wrap--hidden': hideTabs }"
    class="search-tabs-wrap">
    <div class="search-tabs">
      <search-tab
        v-for="tab in tabs"
        :activeTab="activeTab"
        :key="tab.name"
        :tabName="tab.name"
        @activeTab="setActiveTab">
        {{ tab.title }}
      </search-tab>
    </div>

    <portal-target name="desktop"></portal-target>

    <div class="search-field-list-select">
      <search-experiences v-show="activeTab === 'experiences'" />
      <search-competences v-show="activeTab === 'skills'" />
      <search-languages
        v-show="activeTab === 'languages'">
      </search-languages>
      <search-asylum-status
        v-show="activeTab === 'asylumStatus'">
      </search-asylum-status>
      <search-education
        v-show="activeTab === 'educations'">
      </search-education>
      <search-location v-show="activeTab === 'city'" />
    </div>
    
  </div>
</template>

<script>
import SearchTab from './SearchTab'
import SearchExperiences from './SearchExperiences'
import SearchCompetences from './SearchCompetences'
import SearchAsylumStatus from './SearchAsylumStatus'
import SearchEducation from './SearchEducation'
import SearchLanguages from './SearchLanguages'
import SearchLocation from './SearchLocation'
import { mapState } from 'vuex'
import * as types from '@/store/actionTypes'
import { testMobileDevice } from '@/utils/helpers'

export default {
  name: 'SearchTabs',
  components: {
    SearchExperiences,
    SearchTab,
    SearchCompetences,
    SearchAsylumStatus,
    SearchEducation,
    SearchLanguages,
    SearchLocation
  },

  props: {
    hideTabs: Boolean
  },

  data() {
    return {
      tabs: [
        { name: 'experiences', title: 'Yrke' },
        { name: 'skills', title: 'Kompetens' },
        { name: 'languages', title: 'Språk' },
        { name: 'asylumStatus', title: 'Arbetsstatus' },
        { name: 'educations', title: 'Utbildning' },
        { name: 'city', title: 'Område' }
      ],
      isMobile: false
    }
  },

  computed: {
    ...mapState(['activeTab'])
  },

  methods: {
    setActiveTab(activeTab) {
      this.$store.commit(types.SET_ACTIVE_TAB, activeTab)
    }
  },

  mounted() {
    this.isMobile = testMobileDevice()
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-tabs-wrap {
  @media (--bp-desktop) {
    display: block;
  }
}

.search-tabs-wrap.search-tabs-wrap--hidden {
  display: none;

  @media (--bp-desktop) {
    display: block;
  }
}

.search-tabs {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-top: var(--spacing);
}

.search-field-list-select {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchTabs.vue